import { isTakedaMode } from "@/config/mode";

// Decided once here so isTakedaMode doesn't leak into every datetime consumer.
export const dateTimeDisplay = Object.freeze({
  showViewerLocalTime: isTakedaMode, // convert to viewer's browser tz vs. keep recorded offset
  showOffset: !isTakedaMode,
});
